<!-- Footer -->
<footer class="bg-gray-900 text-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div class="col-span-1 md:col-span-2">
                <img
                    src="../../../assets/images/logo/logo.png"
                    alt="AethyrTech"
                    class="h-10 w-auto mb-4 bg-white rounded p-1"
                />
                <p class="text-gray-400 max-w-sm">
                    The Enterprise Platform for eRetail Intelligence & Retail Media Growth. Unify
                    Content. Optimize Media. Activate Identity.
                </p>
            </div>
            <div>
                <h3 class="text-lg font-semibold mb-4">Platform</h3>
                <ul class="space-y-2">
                    <li>
                        <a
                            href="/platform?#experience"
                            class="text-gray-400 hover:text-white transition"
                            >Experience Cloud</a
                        >
                    </li>
                    <li>
                        <a href="/platform?#media" class="text-gray-400 hover:text-white transition"
                            >Media Cloud</a
                        >
                    </li>
                    <li>
                        <a
                            href="/platform?#identity"
                            class="text-gray-400 hover:text-white transition"
                            >Identity Cloud</a
                        >
                    </li>
                </ul>
            </div>
            <div>
                <h3 class="text-lg font-semibold mb-4">Company</h3>
                <ul class="space-y-2">
                    <li>
                        <a href="/about" class="text-gray-400 hover:text-white transition"
                            >About Us</a
                        >
                    </li>
                    <li>
                        <a href="/market" class="text-gray-400 hover:text-white transition"
                            >Markets</a
                        >
                    </li>
                    <li>
                        <a href="/contact" class="text-gray-400 hover:text-white transition"
                            >Contact</a
                        >
                    </li>
                    <li>
                        <a href="/portal_login" class="text-gray-400 hover:text-white transition"
                            >Customer Login</a
                        >
                    </li>
                </ul>
            </div>
        </div>
        <div
            class="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center"
        >
            <p class="text-gray-500 text-sm">
                &copy; {{ currentYear }} AethyrTech.AI. All rights reserved.
            </p>
            <div class="flex space-x-6 mt-4 md:mt-0">
                <a href="#" class="text-gray-400 hover:text-white"
                    ><i class="fa-brands fa-linkedin text-xl"></i
                ></a>
                <a href="#" class="text-gray-400 hover:text-white"
                    ><i class="fa-brands fa-twitter text-xl"></i
                ></a>
            </div>
        </div>
    </div>
</footer>

<script>
    // Mobile menu toggle
    const btn = document.getElementById('mobile-menu-btn');
    const menu = document.getElementById('mobile-menu');

    btn.addEventListener('click', () => {
        menu.classList.toggle('hidden');
    });
</script>
